var _style, _g, _circle, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,21H3c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h18c1.1,0,2,0.9,2,2v14C23,20.1,22.1,21,21,21z M21,5H3v14h18V5z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8,
    cy: 8.6,
    r: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,17.1c-0.3,0-0.5-0.1-0.7-0.3l-2.6-2.6l-1.4,1.4c-0.4,0.4-1,0.4-1.4,0l-2.2-2.2l-3.4,3.4c-0.4,0.4-1,0.4-1.4,0 s-0.4-1,0-1.4l4.1-4.1c0.4-0.4,1-0.4,1.4,0l2.2,2.2l1.4-1.4c0.2-0.2,0.4-0.3,0.7-0.3l0,0c0.3,0,0.5,0.1,0.7,0.3l3.3,3.3 c0.4,0.4,0.4,1,0,1.4C18.7,17,18.4,17.1,18.2,17.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,17.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.b770ee710dc0144d4843380ba84d60b7.svg";
export { ForwardRef as ReactComponent };